import React, { useReducer } from 'react';

import ComplementContext from './ComplementContext'
import ComplementReducer from './ComplementReducer'

import { LOADING, LOADING_COMPLEMENT, LOAD_PERIODS, LOADING_PERIOD } from "../../types";

import { Afp, Isapre, Region, Periods } from '../../http_services/complement';

const LoginState = (props) => {

    const initialState = {
        loading: false,
        afp: [],
        isapre: [],
        region: [],
        loadPeriod: false,
        periods: null
    }

    const [state, dispatch] = useReducer(ComplementReducer, initialState);

    const loadComplement = async() => {
        loading();  
        const [region, isapre, afp] = await Promise.all([ Region(), Isapre(), Afp() ]);  
        const data = {regions: region.data, isapres: isapre.data, afps: afp.data};
        dispatch({
            type: LOADING_COMPLEMENT,
            payload: data
          });
        loading();
    }

    const getPeriods =  async() => {
        try{
            loadingPeriod()
            const data = await Periods();
            const periodLst = data.data.sort( (a,b) => a.year - b.year);
            dispatch({
                type: LOAD_PERIODS,
                payload: periodLst
            });
            loadingPeriod()
        }catch(err){
            loadingPeriod()
        }
    }

    const loadingPeriod = () => {
        dispatch({
          type: LOADING_PERIOD
        });
      }
   
    const loading = () => {
        dispatch({
          type: LOADING
        });
      }

    return ( 
        <ComplementContext.Provider
            value={{
                loading: state.loading,
                afp: state.afp,
                isapre: state.isapre,
                region: state.region,
                periods: state.periods,
                loadPeriod: state.loadPeriod,
                loadComplement: loadComplement,
                getPeriods: getPeriods
            }}
        >
            {props.children}
        </ComplementContext.Provider>
     );
}
 
export default LoginState;